/**
 * 台本按句拆行(2026-08-07 R2-b)。
 *
 * ★只做**排版**,不做时间轴。后端 `DhTaskSettings` 只回整段 `script`,不回逐句时长 ——
 *   所以详情页的「台本 ↔ 播放进度联动」这轮不做。按字数估秒去点亮某一句,估错一句
 *   就是指着 A 句说 B 句在念,比不联动更糟。等 api 回逐句时长再接。
 *
 * 拆法:句末标点断句并**保留标点在句尾**;结尾没有标点的残句也算一句(用户没写完的稿常见)。
 */
const SENTENCE_END = /(?<=[。！？!?;；])/;

export function splitScriptLines(script: string | null | undefined): string[] {
  if (!script) return [];
  return script
    .split(SENTENCE_END)
    .map((s) => s.trim())
    .filter(Boolean);
}
